import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { ReactElement, useState } from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { MutationKeyConfig } from '../api/api-helper';
import { InvalidateRoute, useDeleteData } from '../hooks/useDeleteData';
import { ApiErrorComponent } from './api-error.component';
import { LoadingIndicator } from './loading-indicator.component';
import { useAuthorize } from '../hooks/use-authorize';
import { UserPermissionName } from '../models/user-permission-name';

interface DeleteGridButtonProps {
  children: ReactElement;
  data: any;
  deleteMutationConfig: (item: any) => MutationKeyConfig;
  onDeleted?: (value: any) => any;
  invalidateRoute?: InvalidateRoute;
  isDisabled?: boolean;
}

export const DeleteButton = ({
  children,
  data,
  deleteMutationConfig,
  onDeleted,
  invalidateRoute,
  isDisabled = false,
}: DeleteGridButtonProps) => {
  const { isLoading, isError, error, mutateAsync } = useDeleteData(deleteMutationConfig(data), invalidateRoute);
  const [isOpen, setIsOpen] = useState(false);

  const submitHanlder = async () => {
    await mutateAsync();
    onDeleted?.(data);
  };

  const openDialog = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <div className="delete-btn-container">
      <IconButton disabled={isDisabled} aria-label="delete" onClick={openDialog}>
        <Tooltip title={<Typography variant="body1">Delete</Typography>}>{children}</Tooltip>
      </IconButton>

      {isOpen && (
        <Dialog className="modalpopup" title={'CONFIRM DELETE'} onClose={closeDialog}>
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>Are you sure you want to permanently delete?</div>
              <LoadingIndicator isLoading={isLoading} />
              <ApiErrorComponent isError={isError} errorRespnse={error} />
            </div>
          </div>{' '}
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button className="btn btn-sm btn-default btn-lightGrey" onClick={closeDialog} autoFocus>
                Cancel
              </button>
              <button
                className="btn btn-sm btn-danger btn-delete"
                style={{ backgroundColor: isReadOnlyPermission ? '#D7DBDD' : '#FF8A8A', color: isReadOnlyPermission ? 'black' : '#fff' }}
                type="button"
                onClick={submitHanlder}
                disabled={isLoading || isReadOnlyPermission}
              >
                Delete
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};
